module.exports = __webpack_public_path__ + "static/media/gungan_sake_spycy.966732d8.jpeg";